export type AppearanceMode = 'light' | 'dark';

const STORAGE_KEY = 'qelm-dashboard-appearance';
const DEFAULT_APPEARANCE: AppearanceMode = 'light';

function isAppearanceMode(value: string | null): value is AppearanceMode {
  return value === 'light' || value === 'dark';
}

export function readAppearance(): AppearanceMode {
  if (typeof window === 'undefined') return DEFAULT_APPEARANCE;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return isAppearanceMode(stored) ? stored : DEFAULT_APPEARANCE;
}

export function applyAppearance(mode: AppearanceMode): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', mode === 'dark');
  document.documentElement.dataset.appearance = mode;
  document.documentElement.style.colorScheme = mode;
}

export function setAppearance(mode: AppearanceMode): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, mode);
  }
  applyAppearance(mode);
}

export function initializeAppearance(): void {
  applyAppearance(readAppearance());
}
